import { useEffect } from 'react';

const useListTextSelectable = (list_dom: HTMLElement | null, dependency: any[] = []) => {
	useEffect(() => {
		if (!list_dom) return;

		const arr = list_dom.getElementsByTagName('li');

		for (let i = 0; i < arr.length; i++) {
			let x: number;
			arr[i].addEventListener('mousedown', (e: Event) => {
				const _e = e as MouseEvent;
				x = _e.clientX;
			});
			arr[i].addEventListener('click', (e: Event) => {
				const _e = e as MouseEvent;
				if (_e.clientX !== x) _e.stopImmediatePropagation();
			});
		}
		return () => {
			for (let i = 0; i < arr.length; i++) {
				let x: number;
				arr[i].removeEventListener('mousedown', (e: Event) => {
					const _e = e as MouseEvent;
					x = _e.clientX;
				});
				arr[i].removeEventListener('click', (e: Event) => {
					const _e = e as MouseEvent;
					if (_e.clientX !== x) _e.stopImmediatePropagation();
				});
			}
		};
	}, [list_dom, ...dependency]);
};

export default useListTextSelectable;
